import createIcon from '../../createIcon';

/**
 * @component @name DensitySmall
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMkgzVjRIMjFWMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAyMEgzVjIySDIxVjIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDE0SDNWMTZIMjFWMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEgOEgzVjEwSDIxVjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DensitySmall = createIcon('DensitySmall', [
  ['path', { d: 'M21 2H3V4H21V2Z', key: 'ihts9g' }],
  ['path', { d: 'M21 20H3V22H21V20Z', key: 'j14wm8' }],
  ['path', { d: 'M21 14H3V16H21V14Z', key: 'dfps4n' }],
  ['path', { d: 'M21 8H3V10H21V8Z', key: '1udqml' }],
]);

export default DensitySmall;
